import { $api, fetchClient, getAuthHeader } from '@/services/api/client'
import { useToast } from '../use-toast'
import { mapPreference } from '@/services/mapper/preference'
import { RawUserPreference } from '@/types/user'

async function createdNewPreference() {
  const response = await fetchClient.PUT('/preference', {
    headers: getAuthHeader(),
    body: {
      category_ids: [],
      certificate: false,
      company_partnership: false,
      educational_level: [],
      internship: false,
      trophy: false,
      publish_work: false,
      show_only_active: true,
      member_type: [],
      open_date: null,
      closing_date: null,
      prize_number_max: 0,
      prize_number_min: 0,
      region: [],
      sort_by: 'closing_date',
      sort_order: 'asc',
      team_number_max: 0,
      team_number_min: 0,
    },
  })

  if (!response.response.ok) {
    throw new Error('Failed to create new preference')
  }

  return mapPreference(response.data?.data as RawUserPreference)
}

export async function getPreferenceData() {
  const response = await fetchClient.GET('/preference', {
    headers: getAuthHeader(),
  })

  if (!response.response.ok) {
    const result = await createdNewPreference()

    if (!result) {
      throw new Error('Failed to create new preference')
    }

    return result
  }

  return mapPreference(response.data?.data as RawUserPreference)
}

export function usePreferenceData() {
  const { data, isLoading, refetch } = $api.useQuery('get', '/preference', {
    headers: getAuthHeader(),
  })

  return {
    preference: mapPreference(data?.data as RawUserPreference),
    isLoading,
    refetch,
  }
}

export function useUpdatePreference() {
  const { toast } = useToast()

  const {
    mutate: updatePreference,
    error: mutationError,
    isPending: isMutationPending,
  } = $api.useMutation('put', '/preference', {
    onSuccess: () => {
      toast({
        title: 'บันทึกการตั้งค่าเรียบร้อย',
        description: 'การตั้งค่าของคุณได้รับการบันทึกแล้ว',
      })
    },
    onError: () => {
      toast({
        title: 'การบันทึกการตั้งค่าของคุณไม่สำเร็จ',
        description: 'เกิดข้อผิดพลาดระหว่างการบันทึก',
        variant: 'destructive',
      })
    },
  })

  return {
    updatePreference,
    isMutationPending,
    mutationError,
  }
}
